var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotosIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.49983H15.8333M17.1 17.0115C17.3567 16.699 17.5 16.2748 17.5 15.8332V5.83317C17.5 5.3915 17.3567 4.9665 17.1 4.65483C16.8458 4.3415 16.4992 4.1665 16.1375 4.1665H8.65333C7.21583 4.1665 6.9375 2.724 5.68917 2.5215C5.46917 2.48567 5.24083 2.49983 5.01833 2.49983C4.22417 2.49983 3.8275 2.49983 3.515 2.63233C3.11748 2.8013 2.80109 3.11799 2.6325 3.51567C2.5 3.8265 2.5 4.22317 2.5 5.01733V15.8332C2.5 16.2748 2.64333 16.6998 2.9 17.0115C3.155 17.324 3.50167 17.4998 3.86333 17.4998H16.1367C16.4983 17.4998 16.8442 17.3248 17.1 17.0115Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2493 14.1667C12.1334 14.1667 12.9812 13.8155 13.6064 13.1904C14.2315 12.5652 14.5827 11.7174 14.5827 10.8333C14.5827 9.94928 14.2315 9.10143 13.6064 8.47631C12.9812 7.85119 12.1334 7.5 11.2493 7.5C10.3653 7.5 9.51745 7.85119 8.89233 8.47631C8.2672 9.10143 7.91602 9.94928 7.91602 10.8333C7.91602 11.7174 8.2672 12.5652 8.89233 13.1904C9.51745 13.8155 10.3653 14.1667 11.2493 14.1667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotosIcon);
export default __webpack_public_path__ + "static/media/photosIcon.19d75560b4c0778e9f03f05327438767.svg";
export { ForwardRef as ReactComponent };